import { LocalTypes } from '../types/JobAd';
import { merge } from 'lodash';
import Loader, { loadWrap } from './mixins/Loader';
import ApiService from '@jobstairs/axios-api-service';
import TokenService from '../../services/TokenService';
import PushPullAnalysisService from '@/services/PushPullAnalysisService';
import { removeHighlights } from '@/helpers/PushPullHighlights';

export default function (config) {
    const apiService = new ApiService({ baseURL: config.jobAd.baseURL });
    const dataApiService = new ApiService({ baseURL: config.search.baseURL });
    const pushPullAnalysisService = new PushPullAnalysisService(config.jobAd);

    const mapRequestData = config.search.hydrator.request;
    const mapResponseData = config.search.hydrator.response;

    return merge(Loader(), {
        namespaced: true,
        state: {
            score: 0,
            sanitizedText: '',
            title: '',
            data: {},
            highlights: [],
        },
        getters: {},
        actions: {
            async [LocalTypes.actions.LOAD_CUSTOM_JOB_AD](
                { commit },
                { title, fulltext },
            ) {
                await loadWrap(commit, async () => {
                    const data = await pushPullAnalysisService.analyze(
                        removeHighlights(fulltext),
                    );
                    commit(LocalTypes.mutations.SET_DATA, {});
                    commit(LocalTypes.mutations.SET_SCORE, data.score);
                    commit(
                        LocalTypes.mutations.SET_HIGHLIGHTS,
                        data.highlights,
                    );
                    commit(LocalTypes.mutations.SET_SANITIZED_TEXT, data.text);
                    commit(LocalTypes.mutations.SET_TITLE, title);
                });
            },
            async [LocalTypes.actions.LOAD_JOB_AD]({ commit }, { jobId }) {
                await loadWrap(commit, async () => {
                    const requestData = mapRequestData(
                        {
                            properties: config.jobAd.properties,
                        },
                        {
                            [config.jobAd.idProperty]: jobId,
                        },
                    );
                    const headers =
                        TokenService.getAuthenticationHeader()['headers'];
                    const responses = await Promise.all([
                        apiService.get({
                            endpoint: `${config.jobAd.endpoint}/${jobId}`,
                            headers,
                        }),
                        dataApiService.get({
                            endpoint: config.search.endpoint,
                            params: requestData,
                        }),
                    ]);

                    const analysisResponse = responses[0].data;
                    const dataResponse = mapResponseData(responses[1].data);
                    const highlights = analysisResponse.highlights;

                    commit(
                        LocalTypes.mutations.SET_SCORE,
                        analysisResponse.score,
                    );
                    commit(
                        LocalTypes.mutations.SET_HIGHLIGHTS,
                        pushPullAnalysisService.transformHighlights(highlights),
                    );
                    commit(
                        LocalTypes.mutations.SET_SANITIZED_TEXT,
                        analysisResponse.text,
                    );
                    commit(
                        LocalTypes.mutations.SET_TITLE,
                        dataResponse.items[0]['PositionTitle'],
                    );
                    commit(
                        LocalTypes.mutations.SET_DATA,
                        dataResponse.items[0],
                    );
                });
            },
        },
        mutations: {
            [LocalTypes.mutations.SET_SCORE]: (state, score) => {
                if (score < 0.01) {
                    score = 0.01;
                }
                state.score = score;
            },
            [LocalTypes.mutations.SET_SANITIZED_TEXT]: (state, text) => {
                state.sanitizedText = text;
            },
            [LocalTypes.mutations.SET_TITLE]: (state, title) => {
                state.title = title;
            },
            [LocalTypes.mutations.SET_DATA]: (state, data) => {
                state.data = data;
            },
            [LocalTypes.mutations.SET_HIGHLIGHTS]: (state, highlights) => {
                state.highlights = highlights;
            },
        },
    });
}
